module.exports = __webpack_public_path__ + "img/0287-user.3316ada2.svg";